module.exports = __webpack_public_path__ + "img/签章授权.3a895e04.jpg";